export default __webpack_public_path__ + "static/media/all.10d15173.svg";